import { PkDialog } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useCalendarServiceStore } from '../../store';

import DownloadContent from './DownloadContent';

import { useWindowSize } from '@hooks/useWindowSize';
import ReactPortal from '@shared/ReactPortal';
import { useTranslateFn } from '@shared/Translate';

import * as classes from './styles.module.scss';

const SubscriptionPanel = () => {
  const resetSelectedTeams = useCalendarServiceStore((state) => state.resetSelectedTeams);
  const { isMobile } = useWindowSize();
  const t = useTranslateFn();

  const handleClose = () => {
    resetSelectedTeams();
  };

  return (
    <ReactPortal>
      <PkDialog
        isOpen
        size={isMobile ? 'full' : 'large'}
        className={classes.dialog}
        onPkClose={handleClose}
        pk-theme='light'
      >
        <div
          slot='header'
          className='pk-w--100 pk-bg-elevation-01 pk-px--xl pk-py--l pk-font--base-semibold pk-text--text-01 pk-line-height--md pk-font-size--xl2'
        >
          {t('nearly_done')}
        </div>
        <div slot='body' className='pk-d--flex pk-flex--column pk-w--100 pk-px--xl'>
          <DownloadContent />
        </div>
      </PkDialog>
    </ReactPortal>
  );
};

export default memo(SubscriptionPanel);
